import { render, staticRenderFns } from "./mmRadio.vue?vue&type=template&id=6fc20724"
import script from "./mmRadio.vue?vue&type=script&lang=js"
export * from "./mmRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports